<!--
 * @Description  : 抢票选项信息卡片
-->
<template minapp='mpx' xlang='wxml'>
  <view class="scramble-select-card">
    <view class="scramble-select-card-header">
      <view class="station-info">
        <text>{{ curTrainInfo?.from_station_name }}</text>
        <image
          class="arrow-icon"
          src="https://img-hxy021.didistatic.com/static/starimg/img/jsgPNCkSw01692184982568.png"
        />
        <text>{{ curTrainInfo?.to_station_name }}</text>
      </view>
      <view class="other-info">
        {{ totalInfo }}
      </view>
    </view>
    <view class="train-number-select card-item">
      <view class="title">备选车次</view>
      <view wx:if="{{!trainCodeList.length}}" class="train-number-empty" bindtap="goToSelectTrain">
        建议多选
      </view>
      <view wx:else class="train-number-select-item" bindtap="goToSelectTrain">
        {{ trainCodeList.join(' ') }}
      </view>
      <image
        class="right-arrow"
        src="https://img-hxy021.didistatic.com/static/starimg/img/8x2zppExzh1692076532321.png"
        bindtap="goToSelectTrain"
      />
    </view>
    <view class="date-select card-item">
      <view class="title">
        <text>备选日期</text>
        <text class="suggest-text">建议多选</text>
      </view>
      <view class="date-item-container">
        <view
          class="date-item"
          wx:class="{{{'date-item-selected': item.isSelect}}}"
          wx:for="{{refactorDateList}}"
          wx:key="index"
          bindtap="setSelectDateCurList(index)"
          wx:style="{{item.style}}"
        >
          <view class="date-day">
            {{ item.day }}
          </view>
          <view class="date-week date-week-selected">
            {{ item.week }}
          </view>
          <image
            wx:if="{{item.isSelect}}"
            class="select-icon"
            src="https://img-hxy021.didistatic.com/static/starimg/img/xMLmuwUob91692098509356.png"
          />
        </view>
      </view>
    </view>
    <view class="seat-select card-item">
      <view class="title">
        <text>备选座席</text>
        <text class="suggest-text">建议多选</text>
      </view>
      <view class="seat-select-item-container" wx:ref="seatref">
        <view
          class="seat-select-item"
          wx:class="{{{'seat-select-item-selected':item.isSelect}}}"
          wx:for="{{refactorSeatList}}"
          wx:key="index"
          wx:style="{{item.style}}"
          bindtap="setSelectSeatCodeList(item.seat_name)"
        >
          <view class="seat-name">
            {{ item.seat_name }}
          </view>
          <view class="seat-price">
            {{ '¥' + item.highest_ticket_price / 100 }}
          </view>
          <image
            wx:if="{{item.isSelect}}"
            class="select-icon"
            src="https://img-hxy021.didistatic.com/static/starimg/img/xMLmuwUob91692098509356.png"
          />
          <view class="circle left" wx:class="{{{'circle-selected':item.isSelect}}}"></view>
          <view class="circle right" wx:class="{{{'circle-selected':item.isSelect}}}"></view>
        </view>
      </view>
    </view>
    <view class="deadline-select card-item">
      <view class="title">截止时间</view>
      <view class="deadline-text" bindtap="openDeadLine"> 发车前{{ deadLineText }}小时 </view>
      <image
        class="right-arrow"
        src="https://img-hxy021.didistatic.com/static/starimg/img/8x2zppExzh1692076532321.png"
        bindtap="openDeadLine"
      />
    </view>
    <!-- <view class="scramble-select-description">
      <image
        class="description-icon"
        src="https://img-hxy021.didistatic.com/static/starimg/img/FFxuh7lYqd1692183371265.png"
      />
      <view class="description-text">
        实时监控余票，放心退改、抢不到全额退款
      </view>
    </view> -->
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { getDay, getWeek } from '@/utils/baseDate'
  import { innerRouter, pagePath } from '@/common/jump'
  import { setStorage } from '@/utils/storage'
  import { STORAGE_DETAIL_SEARCH_QUERY, STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY } from '@/utils/train-storage'
  import { getStorage } from '@/utils/storage'
  import { formatDate } from '@didi/es-mpx-shared/lib/date'
  import store from '@/store'

  createComponent({
    props: {
      trainCodeList: {
        type: Array,
        value: () => [],
      },
      startDateList: {
        type: Array,
        value: () => [],
      },
      selectDateCurList: {
        type: Array,
        value: () => [],
      },
      selectDateList: {
        type: Array,
        value: () => [],
      },
      trainSeatList: {
        type: Array,
        value: () => [],
      },
      selectSeatCodeList: {
        type: Array,
        value: () => [],
      },
      deadLineHour: {
        type: Number,
        value: 1,
      },
      lastSelectedSeatIndex: {
        type: Number,
        value: 0
      }
    },
    ready() {
      this.lastSelectedSeatIndex && this.$refs?.seatref?._selector?.scroll({
        left: this.lastSelectedSeatIndex * 50,
        behavior: 'smooth',
      })
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo', // 选择的车次坐席数据集
      }),
      refactorDateList() {
        const _refactorDateList = this.startDateList?.map((item, index) => {
          const style = {} 
          const isSelect = this.selectDateCurList.includes(index)
          style['--after'] = isSelect ? 'transparent' : '#D1DBE9'
          return {
            day: getDay(item),
            week: getWeek(item),
            isSelect: this.selectDateCurList.includes(index),
            style
          }
        })
        return _refactorDateList
      },
      refactorSeatList() {
        const _refactorSeatList = this.trainSeatList?.map(item => {
          const style = {} 
          const isSelect = this.selectSeatCodeList?.includes(item.seat_name)
          style['--seatafter'] = isSelect ? 'transparent' : '#D1DBE9'
          return {
            ...item,
            isSelect,
            style,
          }
        })
        return _refactorSeatList
      },
      curTrainInfo() {
        return getStorage(STORAGE_DETAIL_SEARCH_QUERY)
      },
      hasCurTrainInfo() {
        return this.curTrainInfo && Object.keys(this.curTrainInfo).length
      },
      totalInfo() {
        return this.hasCurTrainInfo
          ? `${formatDate(this.curTrainInfo?.start_time, 'MM月dd日')} ${
              this.curTrainInfo?.train_code
            } ${this.selectSeatInfo[0]?.seat_type_name}`
          : ''
      },
      deadLineText() {
        return this.deadLineHour === 0.5 ? '半' : this.deadLineHour
      }
    },
    methods: {
      openDeadLine() {
        this.triggerEvent('openDeadLine')
      },
      setSelectDateCurList(index) {
        this.triggerEvent('setSelectDateCurList', index)
      },
      goToSelectTrain() {
        // 清除备选车次列表页的筛选条件
        setStorage({ key: STORATE_SCRAMBLE_CONDITION_SEARCH_QUERY , data: {}})
        innerRouter.push(pagePath().SEARCHLIST, {
          from: 'home',
          order_type: 'scramble',
          date: this.selectDateList.join('*'),
        })
      },
      setSelectSeatCodeList(code) {
        this.triggerEvent('setSelectSeatCodeList', code)
      },
    },
  })
</script>
<style scoped lang="stylus">
  .scramble-select-card
    width 100%
    display flex
    flex-direction column
    background #fff
    box-sizing border-box
    border-radius 12px 30px 12px 12px
    position relative
    &-header
      margin 0 11px 4.5px 11px
      padding 20px 0
      box-sizing border-box
      display flex
      flex-direction column
      justify-content center
      border-bottom 0.5px solid rgba(209, 219, 233, 0.6)
      .station-info
        display flex
        height 20px
        font-family PingFangSC-Semibold
        font-size 20px
        line-height 20px
        color #000
        align-items center
        .arrow-icon
          height 5px
          width 18px
          margin-left 8px
          margin-right 6px
      .other-info
        margin-top 8px
        font-family PingFangSC-Regular
        font-size 14px
        line-height 14px
        color #999
    .card-item
      display flex
      align-items center
      position relative
      flex-wrap nowrap
      white-space nowrap
      margin-left 11px
      .title
        display flex
        flex-direction column
        font-family PingFangSC-Regular
        font-size 14px
        color #333
        margin-right 24px
        .suggest-text
          font-size 10px
          color #999
          margin-top 4px
          line-height 10px
      .right-arrow
        height 16px
        width 16px
        position absolute
        right 8px
    .train-number-select
      font-family PingFangSC-Medium
      font-size 14px
      line-height 14px
      color #000000
      padding 17px 8px 19px 0px
      .train-number-empty
        flex 1
        color #999
        font-family PingFangSC-Regular
      &-item
        overflow auto
        margin-right 24px
    .date-select
      .date-item-container
        flex 1
        display flex
        .date-item
          height 44px
          width 44px
          display flex
          flex-direction column
          justify-content center
          align-items center
          border-radius 6px
          box-sizing border-box
          position relative
          &:after
            position absolute
            content ''
            width 200%
            height 200%
            border 1px solid var(--after)
            transform-origin 0 0
            transform scale(0.5)
            border-radius 12px
            top 0
            left 0
          &:not(:last-child)
            margin-right 6px
          .date-day
            font-family PingFangSC-Medium
            font-size 14px
            line-height 14px
            color #333
            margin-bottom 4px
          .date-week
            font-family PingFangSC-Regular
            font-size 10px
            line-height 10px
            color #666
            &-selected
              color #000
          &-selected
            border 1px solid #FF5900
    .seat-select
      padding 20px 0 9px 0px
      .seat-select-item-container
        flex 1
        display flex
        overflow auto
        white-space nowrap
        flex-wrap nowrap
        .seat-select-item
          flex-shrink 0
          width 56px
          height 44px
          display flex
          flex-direction column
          justify-content center
          align-items center
          border-radius 6px
          box-sizing border-box
          position relative
          overflow hidden
          font-size 12px
          mask radial-gradient(circle at 3.1px, #0000 3.1px, red 0) -3.1px
          -webkit-mask radial-gradient(circle at 3.1px, #0000 3.1px, red 0) -3.1px
          margin-right 6px
          &:after
            position absolute
            content ''
            width 200%
            height 200%
            box-sizing border-box
            border 1px solid var(--seatafter)
            transform-origin 0 0
            transform scale(0.5)
            border-radius 12px
            top 0
            left 0
          &-selected
            border 1px solid #FF5900
          .seat-name
            font-family PingFangSC-Medium
            font-size 12px
            line-height 14px
            color #000
            margin-bottom 4px
          .seat-price
            font-family PingFangSC-Regular
            font-size 10px
            line-height 10px
            color #666
            &-selected
              color #000
          .circle
            content ''
            position absolute
            background #fff
            width 6px
            height 6px
            border-radius 50%
            border 0.6px solid #D1DBE9
            top 50%
            transform translateY(-50%)
            &.left
              left -3.3px
            &.right
              right -3.3px
            &-selected
              border 1px solid #FF5900
    .deadline-select
      padding 11px 0 18px 0
      box-sizing border-box
      line-height 14px
      .deadline-text
        flex 1
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #000
    .scramble-select-description
      display flex
      align-items center
      height 38px
      width 100%
      background linear-gradient(0deg, #F6F8FA, #F6F8FA), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      box-sizing border-box
      border 2px solid #fff
      border-radius 0 0 12px 12px
      padding-left 16px
      .description-icon
        height 16px
        width 16px
        margin-right 4px
      .description-text
        font-family PingFangSC-Regular
        font-size 12px
        line-height 14px
        color #333
  .select-icon
    height 10px
    width 12px
    position absolute
    bottom 0
    right 0
</style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>